import { DialogContent, Typography } from '@mui/material'

//components
import BottomButton from '../../common/BottomButton'
//types
import { GmailConnectionModalContentProps } from 'types'

const GmailConnectionFinish = ({ hideModal }: GmailConnectionModalContentProps) => {
  return (
    <DialogContent sx={styles.dialogContent}>
      <Typography sx={styles.text}>
        Any purchase that you make in Google Play or the Apple App Store will now automatically give
        you rewards in Playback!
      </Typography>
      <BottomButton style={styles.button} handleClick={hideModal}>
        Continue
      </BottomButton>
    </DialogContent>
  )
}

const styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '21px',
    alignItems: 'center',
  },
  text: {
    fontSize: {
      xs: '16px',
    },
    lineHeight: {
      xs: '22px',
    },
    fontWeight: 500,
  },
  button: { width: '200px', height: '45px', marginTop: '10px' },
}

export default GmailConnectionFinish
